import React from 'react';
import get from 'lodash/get';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookSelectWrapper } from 'src/components/CookbookSelectWrapper/CookbookSelectWrapper';
import { useCorporateFieldsContext } from 'src/components/enterprise/features/Corporate/components/CorporateFieldsData/hooks/useCorporateFieldsContext';

export interface MembershipFeeSelectControlProps {
  name: string;
  id: string;
}

export function MembershipFeeSelectControl({
  name,
  id,
}: MembershipFeeSelectControlProps): JSX.Element {
  const { control, errors } = useFormContext();
  const { corpFieldsData } = useCorporateFieldsContext();
  const membershipOptions = corpFieldsData?.employeeFundedPlans || [];

  return (
    membershipOptions && (
      <CookbookSelectWrapper
        label="Monthly membership fee *"
        name={name}
        id={id}
        options={membershipOptions}
        error={get(errors, name)}
        control={control}
        placeholder="Select fee"
        rules={{
          required: 'Monthly membership fee is required',
        }}
        blockWidth
      />
    )
  );
}
